<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-05-25 14:11:17
 * @LastEditTime: 2023-05-25 14:26:09
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<!-- 方案优势 -->
<template>
  <div class="programmeAdvantage rn-section-gap">
    <section>
      <!-- <div class="container"> -->
      <!-- 标题 -->
      <SectionTitle
        :title="$t('solution.advantages_title')"
        description="ADVANTAGES"
        textAlign="center"
      />
      <!-- 三块内容 -->
      <div class="pro-content">
        <!-- <div class="row"> -->
        <div class="item1">
          <div class="item_card">
            <div class="item-icon">
              <img
                src="../../../../assets/images/IndustrySolution/programmeAdvantage/process-support.png"
                alt=""
              />
            </div>
            <div class="item-title">
              {{ $t("solution.automobile.advantages.tab.tab01") }}
            </div>
            <div
              class="item-text"
              v-html="
                formattedText($t('solution.automobile.advantages.tab.desc01'))
              "
            ></div>
            <div class="bg-image">
              <img
                src="../../../../assets/images/IndustrySolution/programmeAdvantage/bg01.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="item2">
          <div class="item_card">
            <div class="item-icon">
              <img
                src="../../../../assets/images/IndustrySolution/programmeAdvantage/production-management.png"
                alt=""
              />
            </div>
            <div class="item-title">
              {{ $t("solution.automobile.advantages.tab.tab02") }}
            </div>
            <div
              class="item-text"
              v-html="
                formattedText($t('solution.automobile.advantages.tab.desc02'))
              "
            ></div>
            <div class="bg-image">
              <img
                src="../../../../assets/images/IndustrySolution/programmeAdvantage/bg02.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="item3">
          <div class="item_card">
            <div class="item-icon">
              <img
                src="../../../../assets/images/IndustrySolution/programmeAdvantage/quality-traceability.png"
                alt=""
              />
            </div>
            <div class="item-title">
              {{ $t("solution.automobile.advantages.tab.tab03") }}
            </div>
            <div
              class="item-text"
              v-html="
                formattedText($t('solution.automobile.advantages.tab.desc03'))
              "
            ></div>
            <div class="bg-image">
              <img
                src="../../../../assets/images/IndustrySolution/programmeAdvantage/bg03.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <!-- </div> -->
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'

export default {
  name: 'programmeAdvantage',
  components: { SectionTitle },
  data () {
    return {

    }

  },
  methods: {
    formattedText (text) {
      // replace(/•(?!$)/g, '<br>•')
      return text.replace(/#/g, '<br>')
    }
  }
}
</script>
